import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { withGenericConfig } from "/contexts/generic-config-context";
import { SINGLE_SOLUTION_PAGE_TYPE, SOLUTIONS_IN_CATEGORY_PAGE_TYPE, SOLUTIONS_HOME_PAGE_TYPE } from "constants/template-center/solution-page-types";
import TemplatePageContent from "template-store/components/template-page-content/template-page-content";
import CategoryPageContent from "template-store/components/category-page-content/category-page-content";
import TemplateHomePageContent from "template-store/components/template-homepage-content/template-homepage-content";
import SearchPageContent from "template-store/components/search-page-content/search-page-content";
import { getCategoryData } from "template-store/services/solution-categories-service";
import { getSolution, getSolutionsInCategory } from "template-store/services/solutions-service";
const MainPageContent = (props)=>{
    const { pageType, allSolutions, allCategories, categoryId, solutionId, searchTerm, filteredSolutions, tabsMetadata, onSearchChange } = props;
    const pageContent = useMemo(()=>{
        switch(pageType){
            case SINGLE_SOLUTION_PAGE_TYPE:
                const solution = getSolution(allSolutions, solutionId);
                return /*#__PURE__*/ _jsx(TemplatePageContent, {
                    templateId: solutionId,
                    template: solution,
                    allCategories: allCategories,
                    tabsMetadata: tabsMetadata
                });
            case SOLUTIONS_IN_CATEGORY_PAGE_TYPE:
                const solutionsToShow = getSolutionsInCategory(allSolutions, categoryId);
                return /*#__PURE__*/ _jsx(CategoryPageContent, {
                    solutions: solutionsToShow,
                    categoryData: getCategoryData(allCategories, categoryId),
                    allCategories: allCategories
                });
            case SOLUTIONS_HOME_PAGE_TYPE:
            default:
                return /*#__PURE__*/ _jsx(TemplateHomePageContent, {
                    allSolutions: allSolutions,
                    allCategories: allCategories,
                    onSearchChange: onSearchChange
                });
        }
    }, [
        pageType,
        allSolutions,
        solutionId,
        allCategories,
        categoryId,
        tabsMetadata,
        onSearchChange
    ]);
    const searchResults = useMemo(()=>{
        return /*#__PURE__*/ _jsx(SearchPageContent, {
            searchTerm: searchTerm,
            filteredSolutions: filteredSolutions,
            allCategories: allCategories,
            onSearchChange: onSearchChange,
            categoryData: getCategoryData(allCategories, categoryId)
        });
    }, [
        allCategories,
        categoryId,
        filteredSolutions,
        onSearchChange,
        searchTerm
    ]);
    return searchTerm ? searchResults : pageContent;
};
export default withGenericConfig(MainPageContent);
